import React from 'react';
import MediaLibraryDialog from 'pages/Dialogs/MediaLibraryDialog';

const Media = () => {
    return (
        <div className="media-library-page">
            <MediaLibraryDialog />
        </div>
    );
};

export default Media;
